export const blockStatuses = {
  blocked: 'blocked',
  unblocked: 'unblocked',
  indeterminate: 'indeterminate',
};
